module.exports = __webpack_public_path__ + "img/8.a0fb936e.png";